import { Cancel, CancelOutlined } from "@mui/icons-material";
import { Box, IconButton, InputBase, SvgIcon } from "@mui/material";
import { useRef, useState } from "react";

const SearchSection = ({
  placeholder,
  onChange = () => {},
}: {
  placeholder: String;
  onChange?: any;
}) => {
  const [val, setVal] = useState("");
  return (
    <Box
      sx={{
        // borderBottom: "1px solid #E2E2E2",
        px: "4%",
        py: "20px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          border: "1px solid #E2E2E2",
          width: "100%",
          px: "20px",
          py: "15px",
          borderRadius: "10px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", gap: "20px", alignItems: "center" }}>
          <img
            src="/assets/img/icons/search_b.svg"
            width="24px"
            height="24px"
            alt=""
          />
          <InputBase
            fullWidth
            placeholder={String(placeholder)}
            onChange={(e) => {
              onChange(e);
              setVal(e.target.value);
            }}
            sx={{
              "::placeholder": {
                color: "#A2A2A2",
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "17px",
              },
            }}
            value={val}
          />
        </Box>
        {val && (
          <IconButton
            size="small"
            onClick={() => {
              setVal("");
              onChange({ target: { value: "" } });
            }}
          >
            <SvgIcon sx={{ color: "#323232" }}>
              <CancelOutlined />
            </SvgIcon>
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default SearchSection;
